import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

/**
 * Label component for form fields.
 *
 * @param {object} props
 * @param {string} props.name - The id of the input element this label is for.
 * @param {string|null} [props.className=null] - Additional class names to apply to the label.
 * @param {string|null} [props.label=null] - The text to display inside the label.
 * @returns {JSX.Element|null}
 */
const Label = ({
  name,
  className = null,
  label = null,
}) => (
  label ? (
    <label htmlFor={name} className={classNames(styles.label, className)}>{label}</label>
  ) : null
);

export { Label };
